import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/Cleverpe_Loading.json';

interface LoadingAnimationProps {
  message?: string;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({ message }) => {
  const [displayMessage, setDisplayMessage] = useState(message);
  const [fadeState, setFadeState] = useState('');

  useEffect(() => {
    if (message !== displayMessage) {
      // Start fade out
      setFadeState('fade-out');
      
      // After fade out, change the message and fade in
      const timer = setTimeout(() => {
        setDisplayMessage(message);
        setFadeState('fade-in');
      }, 300);
      
      // Reset fade state after fade in completes
      const resetTimer = setTimeout(() => {
        setFadeState('');
      }, 600);
      
      return () => {
        clearTimeout(timer);
        clearTimeout(resetTimer);
      };
    }
  }, [message, displayMessage]);

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="w-64 h-64 mb-6">
        <Lottie animationData={animationData} loop={true} />
      </div>
      {displayMessage && (
        <div className={`px-6 text-center transition-opacity duration-300 ${
          fadeState === 'fade-out' ? 'opacity-0' : 
          fadeState === 'fade-in' ? 'opacity-100' : 
          'animate-pulse opacity-100'
        }`}>
          <p className="text-lg font-semibold text-gray-800 dark:text-gray-200">{displayMessage}</p>
        </div>
      )}
    </div>
  );
};

export default LoadingAnimation; 